import dynamic from 'next/dynamic'

export const Block = dynamic(() => import('./block'))
